import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@lmc-env/environment';

export interface EmailSender {
	name: string;
	email: string;
}

@Injectable({
	providedIn: 'root',
})
export class EmailSenderService {
	private apiUrl = `${environment.DO_URL}/v1/emails/senders`;

	constructor(private http: HttpClient) {}

	/**
	 * Get all email senders
	 */
	getEmailSenders(): Observable<EmailSender[]> {
		return this.http.get<EmailSender[]>(this.apiUrl);
	}
}
